import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import { Authentication } from "@swegon/sds-core";

const AuthorizationRoute = ({ component: Component }) => {
    const { isAuthenticated, checkProdAuthority } = useContext(Authentication.AuthContext);
    if (isAuthenticated()) {
        return <Component />;
    }

    checkProdAuthority(window.location);

    return (
        <Navigate to="/login"/>
    );
};

export default AuthorizationRoute;
